import {AppConfigStore, BlogStore, HeaderStore, LoginStore, PageStore, SubscriptionStore} from '../../stores';
import {DownloadNowHeaderBlock as HeaderBlock, VideoText} from '../../components';

import { BlogActions } from 'epic-minimalist-blog/app/scripts/actions';
import Message from '../../components/message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import {connectToStores} from 'epic-alt-utils';
import {generateRoutePath} from 'epic-common/src/route';
import {withRouter} from 'react-router';

/**
 * HomePage View.
 */
@connectToStores
class DownloadNowView extends React.Component {
    static getStores() {
        return [PageStore, SubscriptionStore, HeaderStore, BlogStore, AppConfigStore, LoginStore];
    }

    static getPropsFromStores() {
        return {
            subscriptionStore: SubscriptionStore.getState(),
            pageStore: PageStore.getState(),
            blogStore: BlogStore.getState(),
            loginStore: LoginStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            mobile: HeaderStore.getState().mobile(),
            tablet: HeaderStore.getState().tablet()
        };
    }

    static getInitialActions() {
        return [
            (props) => {
                // reset blog store state so it won't read state from news page
                BlogActions.setStoreState({
                    blogList: []
                });
                BlogActions.getBlogData({
                    category: 'all',
                    rootPageSlug: DownloadNowView.defaultProps.rootPageSlug,
                    initCount: props.postsPerPage
                });
            }
        ];
    }

    static defaultProps = {
        routerRootUrl: 'news',
        rootPageSlug: 'blog',
        enableTileChunking: true,
        enableAutoShortDescription: false,
        hideLoadIndicator: false,
        mobilePostNum: 2
    };

    static propTypes = {
        pageStore: PropTypes.object,
        subscriptionStore: PropTypes.object,
        blogStore: PropTypes.object,
        loginStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool
    };

    render() {
        const downloadNowView = this.props.pageStore.downloadNowData;
        const {isSubscribed} = this.props.subscriptionStore;
        const {header, video} = downloadNowView;
        const {isLoggedIn} = this.props.loginStore;
        const {launchedCountries} = this.props.appConfigStore;
        const {appStoreImg} = launchedCountries;
        const isGameLaunched = this.props.appConfigStore.checkGameLaunched();
        return (
            <div className="landingPage">
                <div className="fullpage"><a href={generateRoutePath("/")}><Message code="epic.spyjinx.viewfullsite" /></a></div>
                <HeaderBlock
                    {...this.props}
                    data={header}
                    isGameLaunched={isGameLaunched}
                    appImage={appStoreImg}
                    isLoggedIn={isLoggedIn}
                    isSubscribed={isSubscribed}
                    mobile={this.props.mobile} />
                <VideoText data={video} mobile={this.props.mobile} />
            </div>
        );
    }
}

export default withRouter(DownloadNowView);
